module.exports = __webpack_public_path__ + "static/media/password_recovery_web.56c454d4.webp";